/**
 * Google Analytics SDK Loader for POV
 * POV owns the Google Analytics SDK and sends events directly
 */

export default function initGoogleAnalytics() {
  // Load Google Analytics SDK
  /* eslint-disable */
  (function(i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r;
    i[r] = i[r] || function() {
      (i[r].q = i[r].q || []).push(arguments)
    }, i[r].l = 1 * new Date();
    a = s.createElement(o),
    m = s.getElementsByTagName(o)[0];
    a.async = 1;
    a.src = g;
    m.parentNode.insertBefore(a, m)
  })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
  /* eslint-enable */
  
  // Get token from config
  const getGAToken = () => {
    if (window.pov_config?.VUE_APP_GOOGLE_ANALYTICS_TOKEN) {
      return window.pov_config.VUE_APP_GOOGLE_ANALYTICS_TOKEN;
    }
    return null;
  };

  const token = getGAToken();
  if (token && window.ga) {
    window.ga('create', token, 'auto');
  } else {
    // eslint-disable-next-line no-console
    console.error('[GA Init] No token found!');
  }
}
